export default __webpack_public_path__ + "static/media/showMore-btn.31aae2cb.svg";